import React, { useState, useEffect } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DeleteIcon from '@material-ui/icons/Delete'
import SaveIcon from '@material-ui/icons/Save'
import {
  Paper,
  Table,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  TableBody,
  Button,
  IconButton,
  Grid
} from '@material-ui/core'

import { Container, Espacobase } from './styles';
import api from '../../services/api';

import * as yup from 'yup';
let schema = yup.object().shape({
  username: yup.string().required(),  email: yup.string().email().required(),
  password: yup.string().required(),
});

const iconButtonStyles = theme => ({
  color: 'white',
  marginRight: theme.spacing(2),
  borderRadius: 3
})

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%'
  },
  gridRoot: {
    '& .header-cell': {
      color: 'white',
      fontWeight: 'bold'
    },
    '& .cell': {
      color: 'white'
    },
    '& .controls-header': {
      visibility: 'hidden'
    },
    '& .controls-row': {
      color: 'white',
      padding: 0,
      display: 'flex',
      justifyContent: 'flex-end'
    },
    '& .MuiDataGrid-footer, & .MuiTablePagination-root, & .MuiIconButton-root': {
      color: 'white'
    },
    '& .MuiIconButton-root.Mui-disabled': {
      color: '#888'
    }
  },
  container: {
    maxHeight: 440
  },
  saveButton: {
    backgroundColor: '#c358d4',
    '&:hover': {
      backgroundColor: "#a338c4"
    },
    ...iconButtonStyles(theme)
  },
  deleteButton: {
    backgroundColor: '#e43863',
    '&:hover': {
      backgroundColor: "#d32854"
    },
    ...iconButtonStyles(theme)
  },
  button: {
    background: '#c358d4',
    color: 'white',
    '&:hover': {
      background: '#942ba5'
    }
  }
}))

function Users () {
  const classes = useStyles()
  const [dataRows, setDataRows] = useState([])
  const [errors, setErrors] = useState([])
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [username, setUsername] = useState('');
  const [loading, setLoading] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [showOverlay, setShowOverlay] = useState(false);
  const [overlayContent, setOverlayContent] = useState('');

  const columns = [
    {
      field: 'username',
      headerName: 'Nome de usuário',
      headerClassName: 'header-cell',
      cellClassName: 'cell',
      width: 140,
    },
    {
      field: 'email',
      headerName: 'E-mail',
      headerClassName: 'header-cell',
      cellClassName: 'cell',
      width: 140,
    },
    {
      field: 'password',
      headerName: 'Senha',
      headerClassName: 'header-cell',
      cellClassName: 'cell',
      width: 110,
      renderCell: user => {
        const { id, password, focused } = user
        return (
          <input
            type='password'
            value={password ? password : focused ? '' : 'placeholder'}
            onChange={e => updatePassword(e.target.value, id)}
            onFocus={e => updateFocused(true, id)}
            onBlur={e => updateFocused(false, id)}
          />
        )
      }
    }
  ]

  function userToDataRow (user) {
    return {
      id:       user.id,
      username: user.username,
      email:    user.email,
      password: '',
      focused:  false
    }
  }

  function updatePassword (password, id) {
    let row = dataRows.find(d => d.id == id)
    row.password = password
    setDataRows([...dataRows])
  }

  function updateFocused (focused, id) {
    let row = dataRows.find(d => d.id == id)
    row.focused = focused
    setDataRows([...dataRows])
  }

  useEffect(() => {
    if (!loaded) { 

      api.get('/usuarios')
        .then(res => {
          if (res.status == 200) {
            setDataRows(res.data.map(userToDataRow))
          }
          setLoaded(true)
        })
        .catch(e => console.error(e))
    }
  })

  function handleSubmit() {
    setLoading(true);
    schema
      .validate({
        username,
        email,
        password,
      })
      .then(async () => {
        const { status } = await api.post('/register', {
          username,
          email,
          password,
        });

        console.log(status)
        if (status === 201) {
          setOverlayContent('Usuário criado com sucesso')
          setShowOverlay(true)
          setTimeout(() => setShowOverlay(false), 2600)

          setEmail('')
          setUsername('')
          setPassword('')
        }
      })
      .catch(() => {
        setOverlayContent('Erro ao criar usuário')
        setShowOverlay(true)
        setTimeout(() => setShowOverlay(false), 2600)
      })
      .finally(() => {
        setLoading(false)
      })
  }

  const updateUser = user => {
    api.put('/usuarios/'+user.id, { password: user.password })
      .then(res => {
        console.debug(res)
        if (res.status != 200) return
      })
      .catch(e => setErrors([...errors, { id: user.id, error: e }]))
  }

  const deleteUser = userId => {
    api.delete('/usuarios/'+userId)
      .then(res => {
        console.debug(res)
        if (res.status !== 200) return

        setDataRows(dataRows.filter(user => user.id != userId))
      })
      .catch(e => {
        console.error(e)
        setErrors([...errors, { id: userId, error: e }])
      })
  }

  const createUser = () => {
    const user = {
      username, 
      password,
      email
    }
    api.post('/usuarios', user)
      .then(res => {
        if (res.status !== 201) return

        const id = res.data
        user.id = id
        setDataRows([...dataRows, userToDataRow(user)])
      })
      .catch(e => console.error(e))
  }
  return (
    <>
      <Grid item xs={1} md={1} />
      <Grid item xs={10} md={10} >
        <Container>
          <Paper>
            <TableContainer className={classes.container}>
              <Table stickyHeader aria-label='users table'>
                <TableHead>
                  <TableRow>
                    {columns.map(column => (
                      <TableCell
                        className={column.headerClassName}
                        key={column.field}
                        align={column.align}
                        style={{ minWidth: column.width }}
                      >
                        <b>{column.headerName}</b>
                      </TableCell>
                    ))}
                    <TableCell 
                      key='nav' 
                      align='right'
                      style={{ minWidth: 80 }}  
                    ></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {dataRows.map(user => {
                    const updating = !!user.password
                    return (
                      <TableRow key={user.id}>
                        {columns.map(column => {
                          const value = user[column.field]
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.renderCell ? column.renderCell(user) : value}
                            </TableCell>
                          )
                        })}
                        <TableCell key='control'>
                          <IconButton 
                            className={classes.saveButton}
                            variant='contained' 
                            component='span' 
                            onClick={() => updating && updateUser(user)}
                          >
                            <SaveIcon/>
                          </IconButton>
                          <IconButton 
                            className={classes.deleteButton}
                            variant='contained' 
                            component='span' 
                            onClick={() => deleteUser(user.id)}
                          >
                            <DeleteIcon/>
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    )
                  })}
                  <TableRow key='new-user'>
                    <TableCell key='username'>
                      <input 
                        type='text' 
                        placeholder='Nome de usuário'
                        value={username}
                        onChange={e => setUsername(e.target.value)}
                      />
                    </TableCell>
                    <TableCell key='email'>
                      <input 
                        type='text' 
                        placeholder='E-mail'
                        value={email}
                        onChange={e => setEmail(e.target.value)}
                      />
                    </TableCell>
                    <TableCell key='password'>
                      <input 
                        type='password' 
                        placeholder='Senha'
                        value={password}
                        onChange={e => setPassword(e.target.value)}
                      />
                    </TableCell>
                    <TableCell key='control'>
                      <Button
                        variant='contained'
                        component='span'
                        className={classes.button}
                        onClick={() => createUser()}
                      > 
                        CRIAR USUÁRIO
                      </Button>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Container>
      </Grid>
    </>
  )

  /*
  return (
    <Container>
      <Paper className={classes.root}>
        <TableContainer className={classes.container}>
          <Table stickyHeader aria-label='users table'>
            <TableHead>
              <TableRow>
                {columns.map(column => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    <b>{column.label}</b>
                  </TableCell>
                ))}
                <TableCell 
                  key='nav' 
                  align='right'
                  style={{ minWidth: 80 }}  
                ></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {users.map(user => {
                const updating = updatingIds.includes(user.id)
                const deleting = deletingIds.includes(user.id)
                return (
                  <TableRow key={user.id}>
                    {columns.map(column => {
                      const value = user[column.id]
                      return (
                        <TableCell key={column.id} align={column.align}>
                          {column.format ? column.format(value) : value}
                        </TableCell>
                      )
                    })}
                    <TableCell key='control'>
                      <Button 
                        variant='contained' 
                        component='span' 
                        className={classes.button}
                        onClick={() => !updating && !deleting && updateUser(user)}
                      >
                        { updating ? 'SALVANDO...' : 'SALVAR' }
                      </Button>
                      <Button 
                        variant='contained' 
                        component='span' 
                        className={classes.button}
                        onClick={() => !updating && !deleting && deleteUser(user.id)}
                      >
                        DELETAR
                      </Button>
                    </TableCell>
                  </TableRow>
                )
              })}
              <TableRow key='new-user'>
                <TableCell key='username'>
                  <input 
                    type='text' 
                    placeholder='Nome de usuário'
                    value={username}
                  />
                </TableCell>
                <TableCell key='email'>
                  <input 
                    type='text' 
                    placeholder='E-mail'
                    value={email}
                  />
                </TableCell>
                <TableCell key='password'>
                  <input 
                    type='password' 
                    placeholder='Senha'
                    value={password}
                  />
                </TableCell>
                <TableCell key='control'>
                  <Button
                    variant='contained'
                    component='span'
                    className={classes.button}
                    onClick={() => createUser()}
                  > 
                    CRIAR USUÁRIO
                  </Button>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </Container>
  )
  */
}

export default Users;
